
<template>
  <!--社区身份证-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="pass_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
    >
      <template slot="opt_t" slot-scope="{row}">
        <a-button @click="toDetail(row.member_id)" type="link">{{row.mobile_phone}}</a-button>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import mixin from '../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'passport',
  data () {
    return {
      searchList: [
        { props: ['community_id'], placeholder: '小区', options: [], inputType: 'select' },
        { props: ['mobile_phone'], placeholder: '手机号', options: [], inputType: 'input' },
        { props: ['status'], placeholder: '状态', options: this.$store.state.statusList, inputType: 'select' },
        { props: ['create_date'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' },
        { props: ['areas'], placeholder: '省市', options: [], inputType: 'cascader', changeOnSelect: true },
        { props: ['property_id'], placeholder: '物业', options: [], inputType: 'select' }
      ],
      tableOptList: [],
      rowOptList: [
        { text: '', customRender: true, handle: (row) => this.triggerStatus(row), key: 'status' }
      ],
      columns: [
        { title: 'ID', dataIndex: 'pass_id', align: 'left', width: '' },
        { title: '手机号', dataIndex: 'mobile_phone', align: 'left', width: '', scopedSlots: {customRender: 'action_t'} },
        { title: '小区', dataIndex: 'communityFullName', align: 'left', width: '' },
        { title: '添加时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '状态', dataIndex: 'status_desc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        community_id: '',
        mobile_phone: '',
        status: '',
        create_date: '',
        areas: '',
        property_id: ''
      },
      listApi: {
        url: '/passes',
        resHandle: this.resHandle, // this.resHandle
        searchHandle: '' // searchHandle
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      this.propertySelect(5);
      this.communitySelect(0, 'searchList', 1);
      this.regionSelect(4);
    },
    /* 查看会员详情 */
    toDetail (id) {
      this.$router.push({
        name: 'memberDetail',
        query: { id: id }
      });
    },
    /* 切换通行证状态 */
    triggerStatus (row) {
      this.$put({
        url: `/passes/edit/${row.pass_id}`,
        params: { status: row.status === 1 ? 0 : 1 }
      }).then((res) => {
        this.$message.success('状态切换成功！');
        this.$children[0].getTableList();
      });
    },
    resHandle (res) {
      res.forEach((el) => {
        el.communityFullName = `${el.area} ${el.community_name}`;
      });
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/member/passport.vue